module.exports = __webpack_public_path__ + "img/btn_sm_sign-up.ad7e515.png";